<template>
  <component v-if="initialized" :is="layoutType"></component>
</template>
<script>
import Vue from 'vue';
export default {
  name: 'CeibaStatic',
  data() {
    return {
      initialized: false,
      layoutType: 'c-page-h5',
    };
  },
  computed: {
    canvasStyle() {
      return {
        background: '#ffffff',
      };
    },
  },
  async created() {
    this.initialized = false;
    this.initialize();
    this.initialized = true;
  },
  methods: {
    initialize() {
      console.log('deviceMode=', this.deviceMode);
      this.layoutType = Vue.prototype.$actInfo.layout_type;
      this.$store.commit('UPDATE_ACTINFO', Vue.prototype.$actInfo);
    },
  },
};
</script>

